import { CLEAR_PERMISSIONS, SET_PERMISSIONS, UPDATE_PERMISSION } from "../Action/permissionsActions";

const initialState = {
    permissions: {}, // { menu_1: { read: false, edit: false }, submenu_2: {...} }
};

const permissionsReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_PERMISSIONS:
            return {
                ...state,
                permissions: action.payload,
            };

        case UPDATE_PERMISSION: {
            const { id, type, value } = action.payload;
            return {
                ...state,
                permissions: {
                    ...state.permissions,
                    [id]: {
                        ...state.permissions[id],
                        [type]: value,
                    },
                },
            };
        }

        case CLEAR_PERMISSIONS:
            return {
                ...state,
                permissions: {},
            };

        default:
            return state;
    }
};

export default permissionsReducer;
